// noinspection FunctionNamingConventionJS

import CourseTemplate from '@/models/CourseTemplate.js';
import Model from '@/models/Model.js';
import SectionSettingsTemplate from '@/models/SectionSettingsTemplate.js';

export default class CourseTemplateMenuItem extends Model {
    static entity = 'course_template_menu_items';

    static modelName = 'CourseTemplateMenuItem';

    static fields() {
        return {
            id: this.attr(null),
            parent_id: this.attr(null),
            course_template_id: this.attr(null),
            prerequisite: this.attr(null),
            title: this.attr(null),
            type: this.attr(null),
            uuid: this.attr(null),
            parent: this.attr(null),
            order: this.attr(null),
            completed: this.boolean(false),
            course_authorized_role_id: this.attr(null),
            activity_type: this.attr(null),
            visible_at: this.attr(null),

            ...super.fields(),

            course_template: this.belongsTo(CourseTemplate, 'course_template_id'),
            items: this.hasMany(CourseTemplateMenuItem, 'parent_id'),
        };
    }

    static addActivityTemplate(payload) {
        return this.insert({ data: payload });
    }

    get family() {
        return [this.uuid];
    }

    get text() {
        return this.title || 'Untitled Menu Item';
    }

    get section_template_model() {
        return SectionSettingsTemplate.query().find(this.id);
    }

    get section_type() {
        return this.section_template_model?.type;
    }

    get display_week_number() {
        return this.section_template_model?.display_week_number;
    }
}
